module.exports = __webpack_public_path__ + "lp/img/folder_icon_plus.55eeb5d4.svg";